'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { serviceTicketApi, type ServiceTicket } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  NEW: { bg: '#fff7e8', text: '#ff7d00' },
  IN_PROGRESS: { bg: '#e8f3ff', text: '#3370ff' },
  AWAITING_CUSTOMER: { bg: '#fff8e6', text: '#d4a017' },
  RESOLVED: { bg: '#e6fff0', text: '#0fc66e' },
  CLOSED: { bg: '#f7f8fa', text: '#8f959e' },
};

const SEVERITY_COLORS: Record<string, { bg: string; text: string }> = {
  P0: { bg: '#ffece8', text: '#f53f3f' },
  P1: { bg: '#fff7e8', text: '#ff7d00' },
  P2: { bg: '#fff8e6', text: '#d4a017' },
  P3: { bg: '#f0f0f0', text: '#888' },
};

export default function ServiceTicketsPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  return (
    <SimpleListPage<ServiceTicket>
      title={rm.lists.serviceTickets.title}
      description={rm.lists.serviceTickets.description}
      load={async (p) => (await serviceTicketApi.list(p)).items}
      searchPlaceholder={rm.lists.serviceTickets.searchPlaceholder}
      columns={[
        { key: 'ticketNo', label: rm.fields.ticketNo, width: '180px' },
        { key: 'severity', label: rm.fields.severity, width: '90px', render: (item) => {
          const c = SEVERITY_COLORS[item.severity] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={item.severity} bg={c.bg} color={c.text} />;
        } },
        { key: 'status', label: rm.fields.status, width: '160px', render: (item) => {
          const c = STATUS_COLORS[item.status] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={item.status} bg={c.bg} color={c.text} />;
        } },
        { key: 'issueTypeCode', label: rm.fields.issueTypeCode, width: '140px' },
        { key: 'openedAt', label: rm.fields.openedAt, render: (item) => new Date(item.openedAt).toLocaleString() },
        { key: 'closedAt', label: rm.fields.closedAt, render: (item) => item.closedAt ? new Date(item.closedAt).toLocaleString() : '-' },
      ]}
    />
  );
}
